module.exports = __webpack_public_path__ + "ecf8d5eea15473e3f620fb101870adfe.webp";